import React from 'react'
import { EmptyState } from '@toasttab/buffet-pui-empty-state'
import { WarningOutlineIcon } from '@toasttab/buffet-pui-icons'
import { Trans, t } from '@local/translations'

export default function SectionError(props: {
  message?: string
  className?: string
}) {
  const _message = props.message || t('section-error.unable-to-load')
  return (
    <EmptyState
      className={props.className}
      testId={'section-error'}
      icon={<WarningOutlineIcon />}
    >
      {_message} <br />
      <Trans
        i18nKey='section-error.please-reload'
        components={[
          <a
            className='text-link'
            href={encodeURI(window.location.href)}
            onClick={() => window.location.reload()}
          />
        ]}
      />
      <br />
      <Trans
        i18nKey='section-error.still-not-working'
        components={[
          <a className='text-link' href='mailto:supply@toasttab.com' />
        ]}
      />
    </EmptyState>
  )
}
